"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(node, key, target, easing) {
  let duration = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 200;
  let callback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : () => {};
  const startTime = Date.now();
  const offset = node[key];
  const gap = target - offset;
  let interrupt = false;

  const step = () => {
    const elapsed = Date.now() - startTime;
    const percentage = elapsed / duration;

    if (interrupt) {
      return;
    }

    if (percentage > 1) {
      node[key] = target;
      cleanup();
      callback();
      return;
    }

    node[key] = easing(elapsed, offset, gap, duration);
    requestAnimationFrame(step);
  };

  const cancel = () => {
    interrupt = true;
    cleanup();
    callback();
    return;
  };

  const cleanup = () => {
    node.removeEventListener('wheel', cancel);
    node.removeEventListener('touchstart', cancel);
  };

  node.addEventListener('wheel', cancel, {
    passive: true
  });
  node.addEventListener('touchstart', cancel, {
    passive: true
  });
  step();
  return cancel;
}